import { createRouter, createWebHistory } from 'vue-router'
import HomeView from '../views/HomeView.vue';
import Home from '../views/Home.vue';
import CreateUser from '../views/CreateUser.vue';
import UserAccount from '@/views/UserAccount.vue';
import NewOrderPage from '@/views/NewOrderPage.vue';
import NotFoundPage from '@/views/NotFoundPage.vue';

const routes = [
  {
    path: '/',
    name: 'home',
    component: Home
  },
  {
    path: '/createUser',
    name: 'createUser',
    component: CreateUser,
  },
  {
    path: '/userAccount',
    name: 'userAccount',
    component: UserAccount,
  },
  {
    path: '/lab/order',
    name: 'newOrder',
    component: NewOrderPage
  },
  {
    path: '/:pathMatch(.*)*',
    name: 'notFound',
    component: NotFoundPage
  }
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
})

export default router
